import { jsx, jsxs } from 'react/jsx-runtime';
import { FlipWords } from '../../Components/ui/flip-words.js';
import { useSuggestedQueries } from '../../api/cache/appConfigQueryOptions.js';
import { useTheme } from '@mui/material';
import { Sparkles } from 'lucide-react';
import { memo, useMemo } from 'react';
import { AnimatedMasonryGrid } from './AnimatedMasonryGrid.js';
import { ConciergeWelcomeEmbedded } from './ConciergeWelcomeEmbedded.js';
import { usePageContext } from '../hooks/usePageContext.js';

function FlipWordsDemo() {
    const words = [
        'find the perfect gift for your mom',
        'save on your weekly grocery shopping',
        'find a Halloween costume for your dog',
    ];
    const theme = useTheme();
    return (jsxs("div", Object.assign({ className: "tw:text-4xl tw:font-bold tw:text-left tw:max-w-[350px] md:tw:max-w-[500px] tw:h-[200px] md:tw:h-[200px] tw:pl-[18px] md:tw:pl-[43px]", style: {
            color: theme.palette.text.primary,
        } }, { children: ["Use Concierge to ", jsx(FlipWords, { words: words, duration: 4000 })] })));
}
const ConciergeWelcomeComponent = ({ trendingSearches, onSearch, brandId, isEmbedded = false, apiBaseUrl, userFirstName: _userFirstName, pageContext: providedPageContext, }) => {
    const { data, isLoading: isLoadingSuggestedQueries } = useSuggestedQueries(brandId, apiBaseUrl);
    const theme = useTheme();
    // Memoize suggestedQueries to keep the full objects (with imageUrl)
    const suggestedQueries = useMemo(() => (data === null || data === void 0 ? void 0 : data.suggestedQuestions) || (trendingSearches === null || trendingSearches === void 0 ? void 0 : trendingSearches.map((search) => ({ query: search.text, imageUrl: '' }))) || [], [data === null || data === void 0 ? void 0 : data.suggestedQuestions, trendingSearches]);
    // Extract just query strings for the masonry grid (non-embedded mode)
    const displayQueries = useMemo(() => suggestedQueries.map((item) => item.query), [suggestedQueries]);
    // Get page context (use provided or fallback to hook)
    const hookPageContext = usePageContext();
    const pageContext = providedPageContext !== null && providedPageContext !== void 0 ? providedPageContext : hookPageContext;
    // Custom welcome screen for embedded mode (text suggestions)
    if (isEmbedded) {
        return (jsx(ConciergeWelcomeEmbedded, { displayQueries: displayQueries, isLoadingSuggestedQueries: isLoadingSuggestedQueries, onSearch: onSearch, pageContext: pageContext, apiBaseUrl: apiBaseUrl }));
    }
    // Full welcome screen for non-embedded mode (FlipWords + masonry grid)
    return (jsxs("div", Object.assign({ style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '40px 20px',
            textAlign: 'center',
            width: '100%',
            height: '100%',
            boxSizing: 'border-box',
            overflow: 'auto',
        } }, { children: [jsx(FlipWordsDemo, {}), displayQueries.length > 0 && !isLoadingSuggestedQueries && (jsxs("div", Object.assign({ style: { width: '100%', maxWidth: '1200px' } }, { children: [jsxs("div", Object.assign({ style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            marginBottom: '28px',
                        } }, { children: [jsx(Sparkles, { style: {
                                    width: '18px',
                                    height: '18px',
                                    color: theme.palette.text.secondary,
                                } }), jsx("h3", Object.assign({ style: {
                                    fontSize: '15px',
                                    fontWeight: '600',
                                    color: theme.palette.text.secondary,
                                    margin: 0,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.05em',
                                } }, { children: "For you" }))] })), jsx(AnimatedMasonryGrid, { items: displayQueries, onItemClick: onSearch })] })))] })));
};
// Memoize to prevent re-renders when parent re-renders due to input changes
const ConciergeWelcome = memo(ConciergeWelcomeComponent);

export { FlipWordsDemo, ConciergeWelcome as default };
//# sourceMappingURL=ConciergeWelcome.js.map
